const getStatusByLang = (status, t) => {
    switch (status) {
        case 'VERIFIED':
            return t("Global.Prescriptions.Status.Verify");
        case 'EXPIRED':
            return t("Global.Prescriptions.Status.Expired");
        case 'REMOVED':
            return t("Global.Prescriptions.Status.Removed");
        case 'ON HOLD':
            return t("Global.Prescriptions.Status.OnHold");
        case 'ASSIGNED':
            return t("Global.Prescriptions.Status.Assigned");
        case 'PICKED UP':
            return t("Global.Prescriptions.Status.PickedUp");
        case 'AMOUNT UPDATE':
            return t("Global.Prescriptions.Status.AmountUpdate");
        case 'STOCKED':
            return t("Global.Prescriptions.Status.Stocked");
        case 'MANUAL OVERRIDE':
            return t("Global.Prescriptions.Status.ManualOverride");
        case 'COMPLETED':
            return t("Global.Prescriptions.Status.Completed");
        case 'OUT FOR DELIVERY':
            return t("Global.Prescriptions.Status.OutForDelivery");
        case 'CANCEL':
            return t("Global.Prescriptions.Status.Cancel");
        case 'OFFLINE CONSULTATION': 
            return t("Global.Prescriptions.Status.OfflineConsultation");
        case 'ARRIVED':
            return t("Global.Prescriptions.Status.Arrived");
        case 'Ready':
            return t("Global.Prescriptions.Status.Ready");
        default:
            break;
    }
}

export default getStatusByLang



// WEBPACK FOOTER //
// ./src/components/common/statusByLang.js